import { CheckboxGroupInput, ReferenceInput, required, SelectInput, TextInput } from "react-admin";
import { VehicleFormToolbar } from "../../misc/VehicleFormToolbar";
import { Form2 } from "../../misc/Form2";
import { Column } from "../../misc/Column";
import type { SxProps } from "@mui/material";
import { useAutovioContext } from "../../hooks/useAutovioContext";
import { WeeklyHoursInput } from "../../inputs/WeeklyHoursInput";

export function SimulatorForm({ mode, sx }: { mode: "create" | "edit"; sx?: SxProps }) {
  const [{ drivingSchoolId }] = useAutovioContext();

  if (!drivingSchoolId) {
    return null;
  }

  return (
    <Form2
      warnWhenUnsavedChanges
      defaultValues={{
        type: "simulator",
        drivingSchoolId,
        name: "",
        notes: "",
        branchId: null,
        minHoursInAdvance: 12,
        maxDaysInAdvance: 14,
        // We cannot simply possibleSimulatorDrivingLessonDurations: ... as a default value,
        // because react-admin does not correctly initialize the form state in edit mode ...
        ...(mode === "create" ? { possibleSimulatorDrivingLessonDurations: [45, 90] } : {}),
        availabilities: [],
      }}
    >
      <Column sx={sx}>
        <TextInput label="Name" source="name" fullWidth autoFocus={mode === "create"} validate={required()} />
        <TextInput label="Notizen" source="notes" fullWidth />
        <ReferenceInput source="branchId" reference="branches" filter={{ drivingSchoolId }}>
          <SelectInput label="Filiale" size="small" validate={required()} />
        </ReferenceInput>
        <SelectInput
          label="Mindest-Vorlaufzeit für Buchung durch Fahrschüler"
          helperText="Gibt an, wie viele Stunden oder Tage im Voraus ein Termin mindestens gebucht werden muss."
          className="with-helper-text"
          size="small"
          validate={required()}
          source="minHoursInAdvance"
          choices={simulatorMinHoursInAdvanceOptions}
        />
        <SelectInput
          label="Maximaler Buchungshorizont"
          helperText="Bestimmt, wie weit im Voraus Fahrschüler Terminvorschläge sehen können."
          className="with-helper-text"
          size="small"
          validate={required()}
          source="maxDaysInAdvance"
          choices={simulatorMaxDaysInAdvanceOptions}
        />
        <CheckboxGroupInput
          label="Mögliche Fahrstundendauern"
          source="possibleSimulatorDrivingLessonDurations"
          choices={possibleSimulatorDrivingLessonDurations}
          validate={required("Bitte wähle mindestens eine Option")}
        />
        <WeeklyHoursInput label="Verfügbarkeiten" source="availabilities" />
        <VehicleFormToolbar />
      </Column>
    </Form2>
  );
}

const simulatorMaxDaysInAdvanceOptions = [
  { id: 7, name: "1 Woche" },
  { id: 14, name: "2 Wochen" },
  { id: 21, name: "3 Wochen" },
  { id: 28, name: "4 Wochen" },
  { id: 35, name: "5 Wochen" },
  { id: 42, name: "6 Wochen" },
];

const simulatorMinHoursInAdvanceOptions = [
  { id: 0, name: "keine" },
  { id: 12, name: "12 Stunden" },
  { id: 24, name: "24 Stunden" },
  { id: 48, name: "2 Tage" },
  { id: 72, name: "3 Tage" },
  { id: 96, name: "4 Tage" },
  { id: 120, name: "5 Tage" },
  { id: 144, name: "6 Tage" },
];

const possibleSimulatorDrivingLessonDurations = [
  { id: 45, name: "45 Minuten" },
  { id: 90, name: "90 Minuten" },
  { id: 135, name: "135 Minuten" },
  { id: 180, name: "180 Minuten" },
];
